module.exports = __webpack_public_path__ + "static/media/Winc_Eindopdracht.b37697cd.png";